import { Howl } from 'howler';

let backgroundSound = null;
let isMuted = false;

Howl.autoUnlock = false;

// Hilfsfunktionen für Plattform-Erkennung
function isIOS() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}

function isMobile() {
    return /Mobi|Android/i.test(navigator.userAgent);
}

const useHtml5Audio = isIOS() || isMobile();

// Universelle Howl-Factory
function createHowl(src, options = {}) {
    return new Howl({
        src,
        ...options,
        ...(useHtml5Audio ? { html5: true } : {}),
    });
}

// Ereignissounds definieren
const eventSounds = {
    event1: createHowl(['./assets/sounds/Zollstock.mp3'], { volume: isMuted ? 0 : 1.0, preload: true }),
    event2: createHowl(['./assets/sounds/Pferd.mp3'], { volume: isMuted ? 0 : 1.0, preload: true }),
    event3: createHowl(['./assets/sounds/Hand.mp3'], { volume: isMuted ? 0 : 1.0, preload: true }),
    event4: createHowl(['./assets/sounds/Blume.mp3'], { volume: isMuted ? 0 : 1.0, preload: true }),
    event5: createHowl(['./assets/sounds/Flutschfinger.mp3'], { volume: isMuted ? 0 : 1.0, preload: true }),
    event6: createHowl(['./assets/sounds/Torbogen.mp3'], { volume: isMuted ? 0 : 1.0, preload: true }),
    event7: createHowl(['./assets/sounds/G.mp3'], { volume: isMuted ? 0 : 1.0, preload: true }),
    event8: createHowl(['./assets/sounds/Treppe.mp3'], { volume: isMuted ? 0 : 1.0, preload: true }),
    event9: createHowl(['./assets/sounds/Wischen.mp3'], { volume: isMuted ? 0 : 1.0, preload: true }),
    event10: createHowl(['./assets/sounds/Wischen.mp3'], { volume: isMuted ? 0 : 1.0, preload: true }),
    event11: createHowl(['./assets/sounds/Default_Sound.mp3'], { volume: isMuted ? 0 : 1.0, preload: true }),
    event12: createHowl(['./assets/sounds/Blaettern.mp3'], { volume: isMuted ? 0 : 1.0, preload: true }),
    event13: createHowl(['./assets/sounds/Zeichnen.mp3'], { volume: isMuted ? 0 : 1.0, preload: true }),
    event14: createHowl(['./assets/sounds/Bass.wav'], { volume: isMuted ? 0 : 1.0, preload: true }),
    event15: createHowl(['./assets/sounds/Magic.wav'], { volume: isMuted ? 0 : 1.0, preload: true }),
};

// Alle Sounds in ein Array für Preloading
const allSounds = [
    {
        name: 'background',
        howl: createHowl(['./assets/sounds/Hintergrundmusik.mp3'], {
            loop: true,
            volume: 0.5,
            preload: true,
        }),
    },
    {
        name: 'background-mobile',
        howl: createHowl(['./assets/sounds/Hintergrundmusik_long.mp3'], {
            loop: true,
            volume: 0.5,
            preload: true,
        }),
    },
    ...Object.entries(eventSounds).map(([name, howl]) => ({ name, howl })),
];

let preloadPromise = null;

// Sounds preloaden (einmalig)
export function preloadAllSounds() {
    if (preloadPromise) return preloadPromise;

    preloadPromise = new Promise((resolve) => {
        let loaded = 0;
        const total = allSounds.length;

        allSounds.forEach(({ howl }) => {
            if (howl.state() === 'loaded') {
                loaded++;
                if (loaded === total) resolve();
                return;
            }

            howl.once('load', () => {
                loaded++;
                if (loaded === total) resolve();
            });

            howl.once('loaderror', (id, error) => {
                console.error('Fehler beim Laden eines Sounds:', error);
                loaded++;
                if (loaded === total) resolve();
            });
        });
    });

    return preloadPromise;
}

// Hintergrundmusik starten
export function startBackgroundSound() {
    backgroundSound = null;
    if (!backgroundSound) {
        const bg = allSounds.find((s) => s.name === (useHtml5Audio ? 'background-mobile' : 'background'));
        //console.log(bg)
        if (bg) backgroundSound = bg.howl;

        //console.log(backgroundSound)
    }

    if (backgroundSound && !backgroundSound.playing()) {
        backgroundSound.play();
    }
}

// Hintergrundmusik stoppen
export function stopBackgroundSound() {
    if (backgroundSound && backgroundSound.playing()) {
        backgroundSound.stop();
    }
}

// Ereignissound abspielen
export function playObjectSound(sound) {
    if (isMuted) return;

    switch (sound) {
        case 'Object_01':
            eventSounds.event1.play(); break;
        case 'Object_02':
            eventSounds.event2.play(); break;
        case 'Object_03':
            eventSounds.event3.play(); break;
        case 'Object_04':
            eventSounds.event4.play(); break;
        case 'Object_05':
            eventSounds.event6.play(); break;
        case 'Object_06':
            eventSounds.event7.play(); break;
        case 'Object_07':
            eventSounds.event8.play(); break;
        case 'Object_08':
            eventSounds.event14.play(); break;
        case 'Object_08_1':
            eventSounds.event5.play(); break;
        case 'Object_09':
            eventSounds.event15.play(); break;
        default:
            eventSounds.event11.play();
            console.warn(`Sound "${sound}" nicht gefunden.`);
            break;
    }
}

export function playEventSound9() {
    if (isMuted) return;
    eventSounds.event9.play();
}

export function playEventSound10() {
    if (isMuted) return;
    eventSounds.event10.play();
}

export function playEventSound12() {
    if (isMuted) return;
    eventSounds.event12.play();
}

export function playEventSound13() {
    if (isMuted) return;
    eventSounds.event13.play();
}

// Beliebigen Sound abspielen
export function playSound(name) {
    const sound = eventSounds[name];
    if (sound) {
        sound.play();
    } else {
        console.warn(`Sound "${name}" nicht gefunden.`);
    }
}

// Funktion zum Stummschalten aller Sounds
export function setMuteAllSounds(muted) {
    isMuted = muted;

    if (backgroundSound) {
        isMuted ? backgroundSound.stop() : startBackgroundSound();
    }
}